export const CURATED_CAROUSEL_TYPES = {
  PROGRAMLIBRARY: 'programLibrary',
  HOMEFEED: 'homeFeed',
  FEATURED: 'featured',
};
